import { Injectable } from '@angular/core';
import _ from 'lodash';
import { environment } from 'environments/environment';
import { APP_SETTINGS } from '../settings';
import notify from 'devextreme/ui/notify';

declare function require(moduleName: string): any;
const { version: appVersion } = require('../../../package.json');

@Injectable()
export class AppInformationService {
    config: any;
    appVersion: string;
    clientVersion: string;
    serviceVersion;
    versionWarning;
    applicationInfo: any;
    serviceName = environment.serviceName;
    isLoggedIn = false;
    title: string;
    pleaseWait = false;
    systemName: string;
    static imageProcessorUrl = 'https://graafschapark.azurewebsites.net/remote.axd';

    private initVersionCheckEvent = new Event('initVersionCheck');

    constructor() {
        this.clientVersion = appVersion;
        this.systemName = this.graafschap ? 'Graafschap ARK' : null;

        document.addEventListener('setAppInfoServiceVersion', (args: any) => {
            if (args && args.detail && args.detail.serviceVersion) {
                this.serviceVersion = args.detail.serviceVersion;
                document.dispatchEvent(this.initVersionCheckEvent);
            }
        });
    }

    get settings() {
        return APP_SETTINGS;
    }

    get neland() {
        return this.settings.church === 'neland';
    }

    get graafschap() {
        return this.settings.church === 'graafschap';
    }

    async pleaseWaitShow() {
        await Promise.resolve(null);
        this.pleaseWait = true;
    }

    async pleaseWaitHide() {
        await Promise.resolve(null);
        this.pleaseWait = false;
    }

    
    notifyToast(message: string, type: 'info' | 'warning' | 'error' | 'success' = 'success', displayTime = 2000, location = 'center top', xOffset = 0, yOffset = 20) {
        let offset = `${xOffset} ${yOffset}`;
        notify({
            position: { my: location, at: location, offset: offset, of: 'body' },
            // position: { my: 'center top', at: 'right bottom', offset: '0 0', of: '.page-main' },
            message,
            closeOnClick: true,
            displayTime,
            width: '400px',
            type
        });
    }
}
